'use strict';

// const _ = require('underscore');
const Base = require('components/Index/IndexFeatures/Blocks/Base/Base.js');

require('./Cards.less');

const Selectors = {
    el: '.IndexFeatures-Cards'
};

// const BindFunctions = [
// ];

module.exports = Base.extend({

    el: Selectors.el,


    initialize: function (options = {}) {
        // _.bindAll(this, BindFunctions);

        this.showDelay = 150;

        Base.prototype.initialize.call(this, options);
    },


    _attachEvents: function () {
        Base.prototype._attachEvents.call(this);
    }
});
